import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta, launchOffer, offerHighlights, offerStack } from '../data/content';
export function OfferStack() {
  return <section id="oferta" className="scroll-mt-4 bg-night" data-id="element-131" data-mp="2pu3qtcw6o5vh">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-132" data-mp="2kw25smf75whd">
        <h2 className="text-center font-display text-[1.75rem] font-semibold uppercase leading-tight tracking-tight text-parchment sm:text-4xl" style={{
        fontSize: "32px"
      }} data-id="element-133" data-mp="2ktz77dzzav11">
          {offerStack.title}
        </h2>

        <img src={offerStack.image} alt="Pack completo de GPS Bíblico: el cuaderno principal con los 73 mapas y los 5 bonos digitales" className="mx-auto mt-8 block h-auto w-full max-w-md object-contain sm:max-w-lg" data-id="element-134" data-mp="1t32waixhb0ge" />

        <div className="mx-auto mt-8 max-w-2xl rounded-2xl border border-gold-soft/45 bg-night-panel p-5 sm:p-7" data-id="element-135" data-mp="1efq2k6xipoex">
          <ul className="divide-y divide-dashed divide-night-line" data-id="element-136" data-mp="19hol1qfqpx5k">
            {offerStack.items.map(item => <li key={item.title} className="flex items-start justify-between gap-4 py-4 first:pt-0 last:pb-0" data-id="element-137" data-mp="14pv6v35lrd8o">
                <p className="font-sans text-[0.95rem] leading-relaxed text-parchment/85" data-id="element-138" data-mp="19mvf9kpxcs2y">
                  <span className="font-semibold text-parchment" data-id="element-139" data-mp="1efxyp00zml5f">{item.title}</span>
                  <span className="text-parchment/60" data-id="element-140" data-mp="1jehppeufun4n"> — {item.description}</span>
                </p>
                <span className="mt-0.5 flex flex-none flex-col items-end font-sans text-sm font-semibold text-gold-soft" data-id="element-141" data-mp="lr0t9xhvkiu3">
                  <span className={item.free ? 'text-parchment/50' : ''} style={{
                ...(item.free ? {
                  textDecorationLine: "line-through"
                } : undefined),
                textDecorationLine: "line-through"
              }} data-id="element-142" data-mp="qq3pcsfvnepx">
                    {item.value}
                  </span>
                  {item.free && <span data-id="element-143" data-mp="273u2eooz5dbp">GRATIS</span>}
                </span>
              </li>)}
          </ul>

          <div className="mt-6 border-t border-night-line pt-6 text-center" data-id="element-144" data-mp="2b4vtujcngl34">
            <p className="font-sans text-sm text-parchment/60" data-id="element-145" data-mp="2b7091xg016ip">
              VALOR TOTAL:{' '}
              <span className="line-through" data-id="element-146" data-mp="c2i7v5vnzqqk">{launchOffer.totalValue}</span>
            </p>
            <p className="mt-2 font-display text-xl font-semibold uppercase text-parchment sm:text-2xl" data-id="element-147" data-mp="73f55s35pwlr">
              {launchOffer.totalLead}
            </p>
            <p className="font-display text-5xl font-semibold text-gold-soft sm:text-6xl" data-id="element-148" data-mp="g3284ibjbagx">
              {launchOffer.price}
            </p>
            <p className="mt-1 font-sans text-sm font-semibold text-gold" data-id="element-149" data-mp="3ofpz5gtbri1q">
              {launchOffer.totalSaveLabel}
            </p>

            <div className="mx-auto mt-7 max-w-md" data-id="element-150" data-mp="21y8k8rpgwaz">
              <CtaButton size="block" href={checkoutUrl} data-id="element-151" data-mp="23izloet9x43">
                {cta.label}
              </CtaButton>
              <p className="mt-3 font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-152" data-mp="3testo7boi5vg">
                {cta.microcopy}
              </p>
              <p className="mt-1 font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-153" data-mp="30shwl6na6n3e">
                {launchOffer.paymentNote}
              </p>
            </div>

            <ul className="mx-auto mt-7 grid max-w-md gap-2 text-left sm:grid-cols-2" data-id="element-154" data-mp="1g82xfxqm47l2">
              {offerHighlights.map(item => <li key={item} className="flex items-start gap-2" data-id="element-155" data-mp="1l2qljvhpezz4">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-gold-soft" aria-hidden="true" data-id="element-156" data-mp="17b2ew7q853pj" />
                  <span className="font-sans text-sm text-parchment/80" data-id="element-157" data-mp="1c8u4gv3ecdqk">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}